import React, { useState } from 'react';
import {
    Grid,
    TextField,
    IconButton,
    InputAdornment,
    Tooltip,
    Snackbar,
    Alert
} from '@mui/material';
import {
    Visibility,
    VisibilityOff,
    ContentCopy,
    Check
} from '@mui/icons-material';
import useStyles from '@/pages/Intranet/Companies/styles';
import { useSnackbar } from 'notistack';

const PasswordField = ({ value, onChange }: { value?: string, onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> }) => {
    const classes = useStyles()
    const [showPassword, setShowPassword] = useState(false);
    const [copySuccess, setCopySuccess] = useState(false);

    const { enqueueSnackbar } = useSnackbar()

    const handleTogglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleCopyPassword = async () => {
        try {
            if (value) {
                await navigator.clipboard.writeText(value);
                enqueueSnackbar(' Senha copiada para a área de transferência!', { variant: 'success' })
                setCopySuccess(true);

                setTimeout(() => {
                    setCopySuccess(false);
                }, 2000);
            }
        } catch (error) {
            console.error('Erro ao copiar senha:', error);
        }
    };


    return (
        <TextField
            id="loopert_teste"
            className={classes.itemInput}
            label="Admin Password"
            value={value || ''}
            onChange={onChange}
            size="small"
            variant="outlined"
            type={showPassword ? 'text' : 'password'}
            inputProps={{
                'data-lpignore': 'true',
                'data-1password': 'true',
                'data-op-ignore': 'true'
            }}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <Tooltip title={copySuccess ? "Copiado!" : "Copiar senha"}>
                            <span>
                                <IconButton
                                    onClick={handleCopyPassword}
                                    edge="end"
                                    size="small"
                                    disabled={!value}
                                    sx={{
                                        marginRight: 0.5,
                                        color: copySuccess ? 'success.main' : 'action.active'
                                    }}
                                >
                                    {copySuccess ? <Check fontSize="small" /> : <ContentCopy fontSize="small" />}
                                </IconButton>
                            </span>
                        </Tooltip>

                        <Tooltip title={showPassword ? "Ocultar senha" : "Mostrar senha"}>
                            <IconButton
                                onClick={handleTogglePasswordVisibility}
                                edge="end"
                                size="small"
                            >
                                {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                            </IconButton>
                        </Tooltip>
                    </InputAdornment>
                )
            }}
        />


    );
};

export default PasswordField;